export default "__VITE_ASSET__BaOV5boN__"